export const REQUEST_ALL_STATE_LIST = 'REQUEST_ALL_STATE_LIST';
export const REQUEST_ALL_STATE_LIST_SUCCESS = 'REQUEST_ALL_STATE_LIST_SUCCESS';
export const REQUEST_ALL_STATE_LIST_ERROR = 'REQUEST_ALL_STATE_LIST_ERROR';

export const REQUEST_ALL_GENDER_LIST = 'REQUEST_ALL_GENDER_LIST';
export const REQUEST_ALL_GENDER_LIST_SUCCESS = 'REQUEST_ALL_GENDER_LIST_SUCCESS';
export const REQUEST_ALL_GENDER_LIST_ERROR = 'REQUEST_ALL_GENDER_LIST_ERROR';